import React from 'react';
import { ComboBoxProps } from '@react-types/combobox';
import { useComboBox, useFilter, useButton } from 'react-aria';
import { useComboBoxState } from 'react-stately';
import { Label, Icon } from '@perch-labs/shrike';
import { ListBox } from 'components/dropdown/components/list-box.component';
import { Popover } from 'components/dropdown/components/popover.component';
import { Wrapper } from 'components/dropdown/dropdown.style';
import { Input, InputWrapper, StyledButton } from './combobox.style';

export const Combobox = <T extends Record<string, unknown>>(
  props: { className?: string } & ComboBoxProps<T>
) => {
  // Setup filter function and state.
  const { contains } = useFilter({ sensitivity: 'base' });
  const state = useComboBoxState({
    ...props,
    defaultFilter: contains,
  });

  // Setup refs and get props for child elements.
  const buttonRef = React.useRef(null);
  const inputRef = React.useRef(null);
  const listBoxRef = React.useRef(null);
  const popoverRef = React.useRef(null);

  const {
    buttonProps: triggerProps,
    inputProps,
    listBoxProps,
    labelProps,
  } = useComboBox(
    {
      ...props,
      inputRef,
      buttonRef,
      listBoxRef,
      popoverRef,
    },
    state
  );

  const { buttonProps } = useButton(triggerProps, buttonRef);

  return (
    <Wrapper className={props.className}>
      <Label
        fontFamily="medium"
        fontSize={300}
        margin={{ bottom: '2px', left: '7px' }}
        {...labelProps}
        color="secondary"
      >
        {props.label}
      </Label>
      <InputWrapper>
        <Input {...inputProps} ref={inputRef} />
        <StyledButton aria-label="test" {...buttonProps} ref={buttonRef}>
          <Icon icon="ChevronDown" />
        </StyledButton>
      </InputWrapper>
      {state.isOpen && (
        <Popover
          popoverRef={popoverRef}
          isOpen={state.isOpen}
          onClose={state.close}
        >
          <ListBox {...listBoxProps} listBoxRef={listBoxRef} state={state} />
        </Popover>
      )}
    </Wrapper>
  );
};
